import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class MessageService extends ApiService {
  namespace = "message";
  icon = "Volume";
  name = "message";
  favicon = "Balloon";
  window = 290;
  Width = 690;
  DOMAIN = DOMAIN.MESSAGE;
  singular = this.terminology.message.singular;
  plural = this.terminology.message.plural;
  vowel = this.terminology.message.vowel;
  action = "action";

  constructor() {
    super("ar-messages");
  }
}
